import { Controller } from '@hotwired/stimulus'
import { mountCallWidget, unmountCallWidget } from '../components/call_center/widget/CallWidget'

// Same breakpoint as beacon compact / Bootstrap xl. Native app sets window.ondeviceai.
const COMPACT_VIEWPORT_BREAKPOINT = 1200

function skipCallWidget() {
  return Boolean(window.ondeviceai) || window.innerWidth < COMPACT_VIEWPORT_BREAKPOINT
}

export default class extends Controller {
  static values = {
    apiBase: String
  }

  connect() {
    if (skipCallWidget()) return
    this.mounted = true
    mountCallWidget(this.element)
  }

  disconnect() {
    if (!this.mounted) return
    this.mounted = false
    unmountCallWidget(this.element)
  }
}
